<template>
    <div class="card">
        <div class="card-header">Address(es)</div>
        <div class="card-body" v-if="!!workDatesApplication">
            <div role="alert">
                <b-row>
                    <b-col>
                        <div class="text-danger" v-if="!$v.workDatesApplication.address.minLength
                        || !$v.workDatesApplication.address.required">
                            At least one valid current address is required.
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="text-danger" v-if="workDatesApplication.address.filter(a => a.preferred === true).length !== 1">
                            Only one address may be marked as the preferred address.
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div v-for="(addr, index) in workDatesApplication.address" :key="addr.id">
                <b-row>
                    <b-col cols="6" lg="4">
                        <BaseSelector v-model="addr.addressType"
                                      :v="$v.workDatesApplication.address.$each[index].addressType"
                                      label="Address Type"
                                      slug="addressType"
                                      :options=opts.addressTypeOptions
                                      :setId="'addressType'+index"
                                      :plaintext="addr.id != null"
                        />
                    </b-col>
                    <b-col cols="2">
                        <BaseCheckboxInput v-model="addr.preferred"
                                           :v="$v.workDatesApplication.address.$each[index].preferred"
                                           label="Preferred address for contact"
                                           slug="preferred"
                                           :setId="'applPreferred'+index"
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseTextInput v-model="addr.streetAddress"
                                       :v="$v.workDatesApplication.address.$each[index].streetAddress"
                                       slug="streetAddress"
                                       label="Street Address"
                                       :setId="'applStreetAddress'+index"
                                       :plaintext="addr.id != null"
                        />
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center" v-if="addr.id != null">
                        <button class="btn btn-warning" @click="updateAddress(index)">
                            Update Address
                        </button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="addr.city"
                                       :v="$v.workDatesApplication.address.$each[index].city"
                                       slug="city"
                                       label="City"
                                       :setId="'applCity'+index"
                                       :plaintext="addr.id != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="3" v-if="!workDatesApplication.international">
                        <BaseSelector v-model="addr.state"
                                      :v="$v.workDatesApplication.address.$each[index].state"
                                      label="State"
                                      slug="state"
                                      :options=opts.stateOptions
                                      :setId="'applState'+index"
                                      :plaintext="addr.id != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="4" v-if="workDatesApplication.international">
                        <BaseTextInput v-model="addr.stateProv"
                                       :v="$v.workDatesApplication.address.$each[index].stateProv"
                                       slug="stateProv"
                                       label="State/Province"
                                       :setId="'stateProv'+index"
                                       :plaintext="addr.id != null"
                        />
                    </b-col>
                    <template v-if="!workDatesApplication.international">
                        <b-col cols="12" lg="3">
                            <BaseMaskedTextInput v-model="addr.postalCode"
                                                 :v="$v.workDatesApplication.address.$each[index].postalCode"
                                                 slug="postalCode"
                                                 label="ZIP"
                                                 :setId="'applZip'+index"
                                                 mask="#####-####"
                                                 :plaintext="addr.id != null"
                            />
                        </b-col>
                        <b-col cols="2" class="d-flex align-items-center">
                            <button class="btn btn-danger mt-2" @click="removeAddress(index)">
                                Remove Address
                            </button>
                        </b-col>
                    </template>
                </b-row>
                <b-row v-if="workDatesApplication.international">
                    <b-col cols="12" lg="3">
                        <BaseTextInput v-model="addr.postalCode"
                                       :v="$v.workDatesApplication.address.$each[index].postalCode"
                                       slug="postalCode"
                                       label="Postal Code"
                                       :setId="'postalCode'+index"
                                       :plaintext="addr.id != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <BaseSelector v-model="addr.country"
                                      :v="$v.workDatesApplication.address.$each[index].country"
                                      slug="country"
                                      label="Country"
                                      :setId="'country'+index"
                                      :plaintext="addr.id != null"
                                      :options=opts.countryOptions
                        />
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center">
                        <button class="btn btn-danger mt-2" @click="removeAddress(index)">
                            Remove Address
                        </button>
                    </b-col>
                </b-row>
            </div>
            <b-row class="mt-2">
                <b-col cols="2">
                    <button class="btn btn-secondary" @click="addAddress">
                        Add Another Address
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
import BaseMaskedTextInput from '@/components/templates/input/BaseMaskedTextInput.vue'
import BaseSelector from '@/components/templates/input/BaseSelector.vue'
import BaseCheckboxInput from '@/components/templates/input/BaseCheckboxInput.vue'
import moment from 'moment'
import { commonOptions } from '@/mixins/commonOptions.js'
import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
import axiosRetry from 'axios-retry'
import axios from "axios"

    export default {
        props: {
            workDatesApplication: {
                type: Object,
                default () {
                    return {
                        address: [{
                            id:null,
                            streetAddress: null,
                            city: null,
                            state: null,
                            stateProv: null,
                            postalCode: null,
                            country: null,
                            addressType: null,
                            preferred: true,
                            applicationId: null
                        }],
                    }
                }
            }
        },

        data: () => {
            return {
                opts: {
                    addressTypeOptions: [
                        { value: 'H', text: 'Home' },
                        { value: 'E', text: 'Employer' },
                    ],
                },
            }
        },
        mixins: [
            commonOptions
        ],
        components: {
            BaseTextInput,
            BaseSelector,
            BaseCheckboxInput,
            BaseMaskedTextInput
        },
        validations() {
            return {
                workDatesApplication: {
                    address: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            streetAddress: { required },
                            city: { required },
                            state: { required: requiredIf(function() { return !this.workDatesApplication.international }) },
                            stateProv: { required: requiredIf(function() { return this.workDatesApplication.international }) },
                            postalCode: { required: requiredIf(function() { return !this.workDatesApplication.international }),
                                maxLength: maxLength(10),
                                minLength: this.workDatesApplication.international ? minLength(3) : minLength(5) },
                            country: { required: requiredIf(function() { return this.workDatesApplication.international }),
                                maxLength: maxLength(30) },
                            addressType: { required },
                            preferred: { checked: value => this.workDatesApplication.address.filter(a => a.preferred === true).length === 1 },
                            id: { required: false },
                            applicationId: { required: false },
                        }
                    },
                },
                form: [ 'workDatesApplication' ]
            }
        },
        methods: {
            updateAddress: function (i) {
                var address = Object.assign({}, this.workDatesApplication.address[i])
                address.changeDate = moment().format('YYYY-MM-DD')
                this.workDatesApplication.prevAddress.push(address)
                this.workDatesApplication.address[i].updatedId = this.workDatesApplication.address[i].id
                this.workDatesApplication.address[i].id = null
                this.setAddressFocus(i)
            },
            removeAddress: function (i) {
                var address = this.workDatesApplication.address[i]
                if (address.id === null) {
                    var filter = this.workDatesApplication.prevAddress.filter(adr => adr.id === address.updatedId)
                    if (filter.length > 0) {
                        var old = filter[0]
                        old.changeDate = null
                        old.removedDate = moment().format('YYYY-MM-DD')
                    }
                } else {
                    address.removedDate = moment().format('YYYY-MM-DD')
                    this.workDatesApplication.prevAddress.push(address)
                }
                this.$delete(this.workDatesApplication.address, i)
            },
            addAddress: function () {
                this.workDatesApplication.address.push({
                    id:null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    stateProv: null,
                    postalCode: null,
                    country: null,
                    addressType: null,
                    preferred: false,
                    applicationId: null
                });
                this.setAddressFocus(this.workDatesApplication.address.length-1)
            },
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
            setAddressFocus(index) {
                setTimeout(() => {
                    document.getElementById('addressType'+index).focus()
                }, 100)
            }
        }
    }
</script>
